import React from "react";
import { Modal, ModalBody, Button, Badge } from "reactstrap";
import { useNavigate } from "react-router-dom";

const BookingAlertModal = ({ isOpen, toggle, booking, onDismiss }) => {
  const navigate = useNavigate();

  if (!booking) return null;

  const bookingId = booking.bookingId || booking.BookingId || booking.id || booking.Id || "New";
  const customerName = booking.customerName || booking.CustomerName || booking.UserName || "Customer";
  const customerMobile = booking.customerMobile || booking.CustomerMobile || booking.UserMobileNo || "";
  const pickup = booking.pickup || booking.pickupAddress || booking.PickupAddress || "Pickup location not specified";
  const drop = booking.drop || booking.dropAddress || booking.Stop1Address || booking.Stop1ReceiverHouseDetails || "Drop location not specified";
  const fare = booking.fare ?? booking.price ?? booking.Price ?? 0;
  const km = booking.km ?? booking.totalTripKM ?? booking.TotalTripKM ?? 0;
  const time = booking.time || booking.BookingDate || new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  const vehicleType = booking.vehicleCategory || booking.VehicleCategory || booking.VehicleTypeName || "";

  const handleAssignClick = () => {
    if (toggle) toggle();
    if (onDismiss) onDismiss();
    navigate("/AssignDriver", { state: { highlightBookingId: String(bookingId) } });
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      backdrop="static"
      keyboard={false}
      style={{
        maxWidth: "480px",
        zIndex: 99999,
      }}
      contentClassName="border-0 shadow-lg"
    >
      <div
        style={{
          background: "linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)",
          color: "#fff",
          padding: "16px 20px",
          borderTopLeftRadius: "6px",
          borderTopRightRadius: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div className="d-flex align-items-center gap-2">
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.25)",
              fontSize: "20px",
            }}
          >
            🚕
          </span>
          <div>
            <h5 className="modal-title mb-0 text-white font-size-16 fw-bold">
              New Ride Booking Alert!
            </h5>
            <small style={{ opacity: 0.9, fontSize: "11px" }}>
              Ride #{bookingId} • {time}
            </small>
          </div>
        </div>

        <button
          type="button"
          onClick={onDismiss || toggle}
          className="btn-close btn-close-white"
          aria-label="Close"
        />
      </div>

      <ModalBody className="p-3 bg-light">
        {/* Customer Box */}
        <div className="bg-white p-2 rounded border mb-2 d-flex justify-content-between align-items-center">
          <div>
            <div className="font-size-11 text-muted text-uppercase fw-semibold">Customer</div>
            <div className="font-size-13 fw-bold text-dark">
              👤 {customerName}
            </div>
            {customerMobile && (
              <div className="font-size-12 text-primary">
                📞 {customerMobile}
              </div>
            )}
          </div>
          <div className="text-end">
            <Badge color="danger" pill className="font-size-12 px-2 py-1">
              🚨 NEW BOOKING
            </Badge>
            {vehicleType && (
              <div className="font-size-11 text-muted mt-1 fw-medium">
                🛺 {vehicleType}
              </div>
            )}
          </div>
        </div>

        {/* Route Details Box */}
        <div className="bg-white p-3 rounded border mb-2">
          <div className="d-flex align-items-start mb-2">
            <span className="me-2 font-size-14" role="img" aria-label="pickup">
              🟢
            </span>
            <div className="overflow-hidden flex-grow-1">
              <div className="font-size-11 text-muted fw-bold text-uppercase">
                Pickup Location
              </div>
              <div className="font-size-12 text-dark fw-medium text-break">
                {pickup}
              </div>
            </div>
          </div>

          <div
            style={{
              borderLeft: "2px dashed #ff4b2b",
              height: "14px",
              marginLeft: "7px",
              marginRight: "7px",
            }}
          />

          <div className="d-flex align-items-start mt-1">
            <span className="me-2 font-size-14" role="img" aria-label="drop">
              🏁
            </span>
            <div className="overflow-hidden flex-grow-1">
              <div className="font-size-11 text-muted fw-bold text-uppercase">
                Drop Location
              </div>
              <div className="font-size-12 text-dark fw-medium text-break">
                {drop}
              </div>
            </div>
          </div>
        </div>

        {/* Fare & Distance Box */}
        <div className="d-flex gap-2">
          <div className="flex-fill bg-white p-2 rounded border text-center">
            <span className="font-size-11 text-muted d-block fw-semibold">Estimated Fare</span>
            <span className="font-size-16 fw-bold text-success">₹{fare}</span>
          </div>
          <div className="flex-fill bg-white p-2 rounded border text-center">
            <span className="font-size-11 text-muted d-block fw-semibold">Trip Distance</span>
            <span className="font-size-16 fw-bold text-primary">{km} KM</span>
          </div>
        </div>
      </ModalBody>

      <div
        className="p-3 bg-white d-flex gap-2 justify-content-end"
        style={{
          borderBottomLeftRadius: "6px",
          borderBottomRightRadius: "6px",
          borderTop: "1px solid #dee2e6",
        }}
      >
        <Button
          color="secondary"
          size="sm"
          className="px-3"
          onClick={onDismiss || toggle}
        >
          Dismiss
        </Button>
        <Button
          color="success"
          size="sm"
          className="px-3 fw-bold d-flex align-items-center gap-1 shadow-sm"
          style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
          onClick={handleAssignClick}
        >
          <i className="bx bx-check-double font-size-16" />
          Assign Driver Now
        </Button>
      </div>
    </Modal>
  );
};

export default BookingAlertModal;
